export type SelectOption = {
  value: SelectOptionValue
  label?: string | null
  disabled?: boolean
  selected?: boolean
  index?: string[]
}

export type SelectOptionValue = string | number | boolean
